module.exports = __webpack_public_path__ + "fonts/iconfont.56cd86d3.woff2";